import { Button, DialogContent, Grid2 as Grid, Paper, styled } from '@mui/material';

export const StyledPaperContainer = styled(Paper)(({ theme }) => ({
	width: '100%',
	marginBottom: theme.spacing(2),
	backgroundColor: 'transparent',
	backgroundImage: 'none',
	boxShadow: 'none',
	[theme.breakpoints.up('sm')]: {
		maxWidth: 700,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
}));

export const StyledSection = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(2.5),
	padding: theme.spacing(1.5, 0),
	width: '100%',
}));

export const StyledHeadSection = styled('div')(({ theme }) => ({
	display: 'grid',
	padding: theme.spacing(1.5),
	rowGap: theme.spacing(1.5),
	width: '100%',
	backgroundColor: theme.palette.common.white,
	borderRadius: 12,
	boxShadow: '0 5px 9px -2px rgba(0,0,0,0.14), 0 -3px 7px -2px rgba(0,0,0,0.08)',
}));

export const StyledButton = styled('div')({
	display: 'flex',
	columnGap: 4,
	justifyContent: 'center',
	alignItems: 'center',
});

export const StyledItemLabel = styled('div')(({ theme }) => ({
	padding: theme.spacing(1, 0, 0.5),
	backgroundColor: 'transparent',
	color: theme.palette.text.primary,
	fontSize: 17,
	fontWeight: 700,
	letterSpacing: '-0.2px',
}));

export const StyledDetailsItem = styled(Grid)(({ theme }) => ({
	color: theme.palette.common.black,
	fontSize: 14,
	fontWeight: 500,
	minWidth: 0,
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
}));

export const StyledLastUserName = styled(StyledDetailsItem)({
	fontSize: 12,
});

export const StyledDetailsItemWrapper = styled(Grid)({
	lineHeight: 'normal',
	flexWrap: 'nowrap',
	minWidth: 0,
	overflow: 'hidden',
});

export const StyledTenantName = styled(Grid)(({ theme }) => ({
	color: theme.palette.common.black,
	fontSize: 12,
	whiteSpace: 'nowrap',
	flexShrink: 0,
}));

export const StyledIconColumnWrapper = styled(Grid)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	width: '24px',
	gap: '8px',
	marginRight: theme.spacing(2),
	[theme.breakpoints.down('sm')]: {
		marginRight: theme.spacing(1.5),
	},
}));

export const StyledIconRowWrapper = styled(Grid)(() => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	alignItems: 'center',
	gap: '8px',
	marginLeft: 'auto',
	flexShrink: 0,
}));

export const StyledButtonWrapper = styled(Grid)(() => ({
	justifyContent: 'end',
	alignItems: 'center',
	display: 'flex',
	marginLeft: 'auto',
}));

export const StyledDetailsWrapper = styled(Grid)({
	alignItems: 'start',
	display: 'grid',
	gridTemplateColumns: 'minmax(0, 1fr)',
	minWidth: 0,
});

export const StyledCardHead = styled('div')(({ theme }) => ({
	display: 'flex',
	flexWrap: 'nowrap',
	alignItems: 'center',
	columnGap: theme.spacing(1),
	width: '100%',
	minWidth: 0,
}));

export const StyledCardHeadRight = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1),
	marginLeft: 'auto',
	flexShrink: 0,
	fontSize: 12,
}));

export const StyledCardBody = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateColumns: '1fr auto',
	alignItems: 'center',
	columnGap: theme.spacing(1),
	width: '100%',
}));

export const StyledBodyType = styled('div')(({ theme }) => ({
	color: theme.palette.common.black,
	fontSize: 12,
	fontWeight: 500,
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
}));

export const StyledBodyMid = styled('div')(({ theme }) => ({
	color: theme.palette.common.black,
	fontSize: 12,
	paddingLeft: theme.spacing(2.5),
	textAlign: 'left',
	minWidth: 0,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
}));

export const StyledBodyRight = styled('div')(({ theme }) => ({
	color: theme.palette.common.black,
	fontSize: 12,
	textAlign: 'right',
	whiteSpace: 'nowrap',
}));

export const StyledDialogContent = styled(DialogContent)({
	whiteSpace: 'pre-wrap',
	fontSize: 14,
});

export const StyledLockName = styled('span')({
	fontWeight: 500,
});

export const StyledButtonsWrapper = styled('div')({
	display: 'flex',
	columnGap: 10,
});

export const StyledRowItemMemoGrid = styled(Grid)<{ active?: string }>(({ active, theme }) => {
	const ring = active === 'true' ? `0 0 0 2px ${theme.palette.secondary.main}, ` : '';
	return {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'nowrap',
		alignItems: 'stretch',
		padding: 0,
		overflow: 'hidden',
		backgroundColor: theme.palette.common.white,
		borderRadius: 12,
		boxShadow: `${ring}0 5px 9px -2px rgba(0,0,0,0.14), 0 -3px 7px -2px rgba(0,0,0,0.08)`,
	};
});

export const StyledUnitNo = styled('span')(({ theme }) => ({
	fontSize: 18,
	fontWeight: 700,
	lineHeight: 1,
	letterSpacing: '-0.3px',
	color: theme.palette.common.black,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
}));

export const StyledCardContent = styled('div')(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: theme.spacing(0.75),
	padding: theme.spacing(1.5),
}));

export const StyledActionBar = styled('div')(() => ({
	display: 'flex',
	alignItems: 'stretch',
	backgroundColor: '#EDEDED',
	borderTop: '1px solid rgba(0,0,0,0.045)',
}));

export const StyledActionButton = styled('button')(({ theme }) => ({
	flex: 1,
	minWidth: 0,
	background: 'none',
	border: 'none',
	cursor: 'pointer',
	fontFamily: 'inherit',
	fontSize: 11,
	fontWeight: 800,
	letterSpacing: '0.2px',
	textTransform: 'uppercase',
	color: theme.palette.text.primary,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 6,
	whiteSpace: 'nowrap',
	padding: '11px 6px',
	'@media (hover: hover)': {
		'&:hover': { backgroundColor: '#E3E3E3' },
	},
	'&:active': { backgroundColor: '#E3E3E3' },
	'&:not(:first-of-type)': { borderLeft: '1px solid rgba(0,0,0,0.045)' },
	'& svg': { flexShrink: 0 },
	[theme.breakpoints.down(400)]: { fontSize: 10, padding: '10px 4px', gap: 4 },
}));

export const StyledResponsiveButton = styled(Button)(({ theme }) => ({
	whiteSpace: 'nowrap',
	minWidth: 0,
	[theme.breakpoints.down(361)]: {
		fontSize: 12,
	},
}));
